import Box from '@mui/material/Box'
import TextButton from '../TextButton'

const SaveCancelButtons = ({
  className,
  hasError,
  setOnEditMode,
  setConfirmModalOpen
}) => (
  <Box
    className={className}
    sx={{
      alignItems: 'center',
      display: 'flex',
      justifyContent: 'space-between',
      margin: 'auto 0 0 auto',
      width: '100%',
      '& button': { margin: '0 5px' }
    }}
  >
    <TextButton variant='text' clickHandler={() => setOnEditMode(false)}>
      Cancel
    </TextButton>
    <TextButton
      clickHandler={() => {
        if (setConfirmModalOpen) setConfirmModalOpen(true)
      }}
      disabled={hasError}
      type='submit'
    >
      Save
    </TextButton>
  </Box>
)

export default SaveCancelButtons
